import React from "react";
import "../../styles/questionrenderer.css";
import { MathJaxContext, MathJax } from 'better-react-mathjax';
import { convertMathJax } from "../../utils/QuestionsUtils";

const QuestionRenderer = ({ question, index }) => {
    if (!question) return null;

    const { questionType, questionText, details = {} } = question;

    const parseCSV = (csv) => {
        if (!csv) return [];
        return csv
            .trim()
            .split("\n")
            .map((line) => line.split(",").map((cell) => cell.trim()));
    };


    const renderDetail = (detail, index) => {
        switch (questionType) {
            case "MULTIPLE_CHOICE":
            case "OPEN_ENDED":
                // case "TRUE_FALSE":
                return (
                    <ul className="choice-list" key={index}>

                        <li>
                            {convertMathJax(detail?.questionChoice?.trim())}
                        </li>

                    </ul>
                );

            // case "FILL_IN_THE_BLANK":
            //     return (
            //         <h4 key={index}>
            //             {detail?.questionLeft} <u>________</u> {detail?.questionRight}
            //         </h4>
            //     );

            case "MATCHING":
                return (
                    <table className="matching-table" key={index}>
                        <tbody>
                            {(detail?.questionLeft || "")
                                .split(",")
                                .map((left, idx) => {
                                    const right = (detail?.questionRight || "").split(",")[idx] || "";
                                    return (
                                        <tr key={idx}>
                                            <td className="match-cell left">{convertMathJax(left.trim())}</td>
                                            <td className="match-cell arrow">⇔</td>
                                            <td className="match-cell right">{convertMathJax(right.trim())}</td>
                                        </tr>
                                    );
                                })}
                        </tbody>
                    </table>
                );


            case "QUESTION_TABLE":
                return (
                    <>
                        {(detail?.questionCsv || "")
                            .split("\n")
                            .map((line, rowIdx) => {
                                const cells = line.split(",").map(cell => cell.trim());
                                return (
                                    <tr key={rowIdx}>
                                        {cells.map((cell, colIdx) => (
                                            <td key={colIdx} className="match-cell">{convertMathJax(cell)}</td>
                                        ))}
                                    </tr>
                                );
                            })}
                    </>
                );

            case "MATHS_CALCULATION":
                return (detail?.questionMarkup &&
                    <pre className="math-expression" key={index}>
                        {detail?.questionMarkup || "Solve the expression."}
                    </pre>
                );

            default:
                return <span></span>;
        }
    };

    return (
        <div className="question-block">
            <MathJaxContext>

                <h3>
                    {convertMathJax((index + 1) + '. ' + questionText)}
                </h3>
                <div className="question-content">
                    {questionType === "QUESTION_TABLE" ? (
                        // Render only once for QUESTION_TABLE (e.g., from the first detail)
                        <table className="matching-table with-border" key={index}>
                            <tbody>
                                {details.map((detail, index) => renderDetail(detail, index))}
                            </tbody>
                        </table>
                    ) : (
                        // Render all details for other question types
                        details.map((detail, index) => renderDetail(detail, index))
                    )}

                    {question.pictureUrl && (
                        <div className="image-container">
                            <img
                                src={`${process.env.PUBLIC_URL}/images/question/${question.pictureUrl}.png`}
                                alt="picture missing"
                                className="question-image"
                            />
                        </div>
                    )}
                    {/* // additional details as required */}
                    {questionType === "OPEN_ENDED" && (
                        <div key={`open-ended-textarea-${index}`}>
                            <textarea placeholder="Your answer..." disabled />
                        </div>
                    )}

                </div>
            </MathJaxContext>

        </div >
    );
};

export default QuestionRenderer;


